import type { Environment } from '@change-corgi/config/environments';

import { googleAnalyticsTrackingIds } from './data';

export function getGoogleAnalyticsTrackingId(env: Environment): string {
	// eslint-disable-next-line security/detect-object-injection
	return googleAnalyticsTrackingIds[env];
}
